import { ILocalDate } from "../../../entities/calendar";
import { ISlotPattern, TWeekday } from "../../../entities/schedule";
import { SCHEDULE_SLOT_COUNT, SCHEDULE_SLOT_DURATION_MINUTES } from "./constants";
import {
    formatMoscowDateTime,
    getMoscowDateTimeParts,
} from "../../../shared/lib/helpers/moscowDateTime";

const WEEKDAY_BY_DATE_INDEX: Record<number, TWeekday> = {
    0: 'WEEKDAY_SUNDAY',
    1: 'WEEKDAY_MONDAY',
    2: 'WEEKDAY_TUESDAY',
    3: 'WEEKDAY_WEDNESDAY',
    4: 'WEEKDAY_THURSDAY',
    5: 'WEEKDAY_FRIDAY',
    6: 'WEEKDAY_SATURDAY',
}

const pad = (value: number): string => String(value).padStart(2, '0')

export const getLocalDateFromDate = (date: Date): ILocalDate => ({
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
})

export const getDateFromLocalDate = (date: ILocalDate): Date => {
    return new Date(Date.UTC(date.year, date.month - 1, date.day, 12))
}

export const getDateInputValue = (date?: ILocalDate): string => {
    if(!date) return ''

    return `${date.year}-${pad(date.month)}-${pad(date.day)}`
}

export const getLocalDateFromInput = (value: string): ILocalDate => {
    const [year, month, day] = value.split('-').map(Number)

    return {year, month, day}
}

export const addDaysToLocalDate = (date: ILocalDate, days: number): ILocalDate => {
    const nextDate = getDateFromLocalDate(date)
    nextDate.setUTCDate(nextDate.getUTCDate() + days)

    return {
        year: nextDate.getUTCFullYear(),
        month: nextDate.getUTCMonth() + 1,
        day: nextDate.getUTCDate(),
    }
}

export const getTodayLocalDate = (): ILocalDate => {
    const {year, month, day} = getMoscowDateTimeParts(new Date())

    return {year, month, day}
}

export const getSlotPatternFromDateTimeSlot = (startsAt: string, durationSlots: number): ISlotPattern | null => {
    const date = new Date(startsAt)

    if(Number.isNaN(date.getTime())) return null

    const parts = getMoscowDateTimeParts(date)
    const slotIndex = Math.floor((parts.hours * 60 + parts.minutes) / SCHEDULE_SLOT_DURATION_MINUTES)
    const moscowDate = new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12))

    if(slotIndex < 0 || slotIndex >= SCHEDULE_SLOT_COUNT) return null

    return {
        weekday: WEEKDAY_BY_DATE_INDEX[moscowDate.getUTCDay()],
        startSlot: slotIndex,
        durationSlots,
    }
}

export const formatLocalDate = (date?: ILocalDate): string => {
    if(!date) return '—'

    return getDateFromLocalDate(date).toLocaleDateString('ru-RU', {timeZone: 'UTC'})
}

export const formatDateTime = (value: string): string => {
    const date = new Date(value)

    if(Number.isNaN(date.getTime())) return value

    return formatMoscowDateTime(date, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    })
}
